import { addImageParams } from '@/utils/urls';
import { AskForHelp } from './components/AskForHelp/AskForHelp';
import { ShopWithConfidence } from './components/ShopWithConfidence/ShopWithConfidence';
import { useMemo } from 'react';
import { useWindowIsMobile } from '@liveauctioneers/hammer-ui-core/providers';

const DESKTOP_IMAGE_HEIGHT = 392;
const MOBILE_IMAGE_HEIGHT = 240;
const IMAGE_QUALITY = 100;
const IMAGE_VERSION = 1746508317;

export const PurchaseProtectionContent = () => {
    const isMobile = useWindowIsMobile();

    const weAreHereToHelpImageUrl = useMemo(
        () =>
            addImageParams({
                height: isMobile ? MOBILE_IMAGE_HEIGHT : DESKTOP_IMAGE_HEIGHT,
                quality: IMAGE_QUALITY,
                sharpen: true,
                url: 'https://p1.liveauctioneers.com/dist/images/we_are_here_to_help.jpg',
                version: IMAGE_VERSION,
            }),
        [isMobile]
    );
    const shopWithConfidenceImageUrl = useMemo(
        () =>
            addImageParams({
                height: isMobile ? MOBILE_IMAGE_HEIGHT : DESKTOP_IMAGE_HEIGHT,
                quality: IMAGE_QUALITY,
                sharpen: true,
                url: 'https://p1.liveauctioneers.com/dist/images/shop_with_confidence.jpg',
                version: IMAGE_VERSION,
            }),
        [isMobile]
    );

    return (
        <div className="w-full px-md xsMax:px-sm">
            <ShopWithConfidence imageUrl={shopWithConfidenceImageUrl} />
            <AskForHelp imageUrl={weAreHereToHelpImageUrl} />
        </div>
    );
};
